module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h1>'+
((__t=(APP.Tools.icon("device_library")))==null?'':__t)+
' '+
((__t=(device))==null?'':__t)+
'</h1>\n<div class=\'note\'>'+
((__t=(APP.Tools.icon("info-circle")))==null?'':__t)+
' This page is very much a work-in-progress.  Feedback welcomed.</div>\n\n<div id=\'notes\'>'+
((__t=(notes))==null?'':__t)+
'</div>\n\n<h2>Details</h2>\n\n<div id=\'details\' class=\'flex\'>\n	';

		var fields =  Object.keys(model.attributes);
		for (var f in fields) {

		var field = model.attributes[fields[f]];
		
__p+='\n		<div>\n			<div class=\'label\'>'+
((__t=(fields[f]))==null?'':__t)+
'</div><div class=\'value\'>'+
((__t=(model.getf(fields[f])))==null?'':__t)+
'</div>\n		</div>\n	';
 } 
__p+='\n</div>\n\n<h2>Devices</h2>\n<div id=\'devices\'></div>\n\n<h2>Tag Library</h2>\n<div id=\'tag_library\'></div>\n\n<div class=\'btn\' id=\'exit\'>'+
((__t=(APP.Tools.icon("exit")))==null?'':__t)+
' Exit</div>\n<div class=\'btn\' id=\'edit\'>'+
((__t=(APP.Tools.icon("edit")))==null?'':__t)+
' Edit</div>\n';
}
return __p;
};
